
import { LOADING, LOGOUT, SET_MESSAGE, IS_FIRST_LOAD,DELETE_ACCOUNT } from "../../Actions/Types";


import { deleteAccountApi } from "../../Api/UserAction/DeleteAccountApi";
import { UserLogoutActionApi } from "../../Api/UserAction/LogoutActionApi";
import getBaseURL from "../../Helpers/getBaseURL";

// function to get current plan details
const deleteAccountDetails = (
    token: string, // access token
    dispatch: Function, // function to store data
    t: Function, // i18next t function 
    navigate: Function, // navigate function for router
) => {

    // Loading
    dispatch({
        type: LOADING,
        payload: true,
    });

    // api to get current package details
    deleteAccountApi(token).then((response) => {

        // api to perform user logout
        UserLogoutActionApi(token).then((response) => {

            // check if api response is ok
            if (response.status === 200) {

                // Logout
                dispatch({
                    type: DELETE_ACCOUNT,
                });

                dispatch({ type: IS_FIRST_LOAD, payload: false });
                // Logout Msg
                // dispatch({
                //     type: SET_MESSAGE,
                //     payload: {
                //         "toast_message": t("Logout Success Msg", { returnObjects: true }),
                //         "toast_type": "success",
                //         "onclose": null
                //     }
                // });

                // Redirect
                /* navigate("/front/login");
                // Loading false */
                dispatch({
                    type: LOADING,
                    payload: false,
                });

            }

        })
    })
}

export { deleteAccountDetails };